import React, { useEffect, useState } from 'react';
import Router from './router';
import { initSession } from './helper';
import { BrowserRouter } from 'react-router-dom';
import GlobalStyles from './globalStyles';
import Theme from './theme';

class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('App error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h2>Something went wrong</h2>
          <p>Please refresh the page or contact support if the issue persists.</p>
          <button onClick={() => window.location.reload()}>Refresh</button>
        </div>
      );
    }
    return this.props.children;
  }
}

const App: React.FC = () => {
  // The session is an httpOnly cookie JS cannot see, so ask the API once
  // (helper/session.ts) before the route guards decide anything.
  const [sessionChecked, setSessionChecked] = useState(false);
  useEffect(() => {
    initSession().finally(() => setSessionChecked(true));
  }, []);
  if (!sessionChecked) return null;

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Theme>
          <GlobalStyles />
          <Router />
        </Theme>
      </BrowserRouter>
    </ErrorBoundary>
  );
};

export default App;
